// src/pages/usePumpageBaseline.ts
import { useQuery, useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

export function usePumpageBaseline(permitNdx) {
  const { getAccessTokenSilently } = useAuth0();
  const qc = useQueryClient();

  const query = useQuery(
    ["baseline", permitNdx],
    async () => {
      if (!permitNdx) return null;
      const token = await getAccessTokenSilently();
      const { data } = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/api/pumpage-entry/baseline`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { permit_ndx: permitNdx },
        }
      );
      return data; // null or row
    },
    { enabled: !!permitNdx }
  );

  const save = useMutation(
    async (payload) => {
      const token = await getAccessTokenSilently();
      await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/api/pumpage-entry/baseline`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
    },
    { onSuccess: () => qc.invalidateQueries(["baseline", permitNdx]) }
  );

  return { query, save };
}
